var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 24 24","aria-hidden":"true","focusable":"false"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }